var render = function render(){var _vm=this,_c=_vm._self._c;return _c('n-select',{staticClass:"order-type-chager-select",attrs:{"label":"Order type"},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},_vm._l((_vm.types),function(type){return _c('option',{domProps:{"value":type}},[_vm._v(_vm._s(_vm.$t(`orderType.${_vm.$options.filters.camelCase(type)}`)))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }